import React, { FC } from "react";
import solanaLogo from "../../../assets/solanaLogo.svg";
import { localeStringOptions } from "../../../common/constants/common.constants";
import triangle from "../../../assets/triangle.svg";
import "./SellingInfoModal.scss";
const SellingInfoModal: FC<{ sellingPrice: number; youWillGet: number }> = ({
  sellingPrice,
  youWillGet,
}) => {
  return (
    <div className="selling-info-modal__wrapper">
      <div className="selling-info-modal">
        <div className="selling-info-modal__amount-wrapper">
          <p className="selling-info-modal__title">Selling price</p>
          <div className="selling-info-modal__amount-logo">
            <img src={solanaLogo} alt="" />
            <p>{sellingPrice} SOL</p>
          </div>
        </div>
        <div className="selling-info-modal__amount-wrapper">
          <p className="selling-info-modal__title"> You will get</p>
          <div className="selling-info-modal__amount-logo">
            <img src={solanaLogo} alt="" />
            <p>{youWillGet} SOL</p>
          </div>
        </div>
      </div>
      <img src={triangle} alt="" />
    </div>
  );
};

export default SellingInfoModal;
